(function($, w, undefined) {

    function CategoryCTASwiper() {
        this.swiper;
        this.detect();
    }

    CategoryCTASwiper.prototype.detect = function() {
        this.swiper = new Swiper ('.categories-ctas .swiper-container', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            spaceBetween: 24,
            slidesPerView: 3,
            allowTouchMove: false,

            breakpoints: {
                767: {
                    slidesPerView: 1,
                    spaceBetween: 14,
                    allowTouchMove: true
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        })
    };

    w.THF = w.THF || {};
    w.THF.Interface = w.THF.Interface || {};
    w.THF.Interface.CategoryCTASwiper = new CategoryCTASwiper();
})(jQuery, window);